// extracted by css-extract-rspack-plugin
export default {"tabContent":"O5JBB"};